/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Convo {
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import EmployeeAppointmentBookViewEnum = Meevo.Model.EmployeeAppointmentBookViewEnum;
    import IBusinessInfoDataService = Meevo.Components.Common.IBusinessInfoDataService;

    export class ConvoResult {
        public stateName: string;
        public parameters: any;
        public status: ConvoStatus;
        public security: AccessLevel;
        public employeeDoNotPerformServicesList: any;
        public isInCallCenterAndRouteBlocked: boolean;
        public isBrowserTab: boolean;
        public suggestedCommands: ISuggestedConvoCommand[];
        public embeddings: number[];
    }

    export class ConvoMetadata {
        public constructor(public route: string, public securityKey: string | string[], public routeParams: any = {}, public isNewTabPromise: () => ng.IPromise<string> = null) {
        }
    }

    export class ConvoService implements IConvoService {
        private $q: ng.IQService;

        private $states: ng.ui.IStateService;

        private $rootScope: ng.IRootScopeService;

        private routeNames: Meevo.Components.Common.IRouteNames;

        private states: Array<ng.ui.IState>;

        private securityKeys = Meevo.Components.Common.SecurityKeys;

        private securityParts = Meevo.Components.Common.SecurityParts;

        private activeRequestId: string;
        private identityService: any;

        /**
         * Simple map to hold routes corresponding to various keywords
         * This will eventually be replaced by actual resolve logic
         * TODO: Review other strategies for this map (is it worth making the keys an array and then just doing a contains on each until we hit one?) Current way will perform better but difference probably negligable.
         */
        public convoMap: { [keyword: string]: ConvoMetadata; };

        private giftCardNumber: string;
        private packageNumber: string;
        private membershipNumber: string;
        private $translate: angular.translate.ITranslateService;
        private modalService: Meevo.Components.Modal.IModalService;

        private readonly LOGGED_IN_EMPLOYEE_TOKEN = '{{loggedInEmployee}}';

        private get callCenterBlockedRouteNames(): string[] {
            return [
                this.routeNames.inventoryCount,
                this.routeNames.inventoryReturns,
                this.routeNames.employeeSupplyUsage,
                this.routeNames.floorLocation,
                this.routeNames.miscSupplyDefinitions,
                this.routeNames.purchaseOrder,
                this.routeNames.stockLevels,
                this.routeNames.employeeGoal,
                this.routeNames.dashboardGoals,
                this.routeNames.departmentGoal,
                this.routeNames.basicEmailMarketing,
                this.routeNames.pointPromotionCampaign,
                this.routeNames.clientPoint,
                this.routeNames.integrations,
                this.routeNames.marketPricing,
                this.routeNames.ratingsControlPanel,
                this.routeNames.salesRankings,
                this.routeNames.departments,
                this.routeNames.distributors,
                this.routeNames.student,
                this.routeNames.teachers,
                this.routeNames.equipment,
                this.routeNames.manufacturers,
                this.routeNames.clientIntake,
                this.routeNames.swapGroups,
                this.routeNames.productBundles,
                this.routeNames.productCategories,
                this.routeNames.product,
                this.routeNames.resourceCategory,
                this.routeNames.resources,
                this.routeNames.serviceCategories,
                this.routeNames.services,
                this.routeNames.addOnGroup,
                this.routeNames.visitNoteTypes,
                this.routeNames.appointmentBook,
                this.routeNames.appointmentCategories,
                this.routeNames.blockTypes,
                this.routeNames.cancellationReasons,
                this.routeNames.confirmationManager,
                this.routeNames.standingAppointments,
                this.routeNames.standingAppointments,
                this.routeNames.standingBlocks,
                this.routeNames.waitList,
                this.routeNames.walkinManager,
                this.routeNames.walkinManagerDisplay,
                this.routeNames.walkinManagerKiosk,
                this.routeNames.eventSchedules,
                this.routeNames.notificationSetting,
                this.routeNames.notificationTemplates,
                this.routeNames.onlineBookingSettings,
                this.routeNames.selfCheckInKioskSettings,
                this.routeNames.walkinManagerSettings,
                this.routeNames.fiveStarRatingSetting,
                this.routeNames.emmaAccountSettings,
                this.routeNames.onlinePresenceManagement,
                this.routeNames.onlinePresenceSettings,
                this.routeNames.systemToolbox,
                this.routeNames.meevoTheming,
                this.routeNames.inventoryTransfer,
                this.routeNames.clientApp,
                this.routeNames.usageReasons,
                this.routeNames.onlineMembershipSettings,
                this.routeNames.salonInteractive,
                this.routeNames.charts,
                this.routeNames.clientRecordManagement
            ];
        }

        private get reportsCategoriesBlockedAtCallCenter(): Model.ReportsCategoryEnum[] {
            return [
                Model.ReportsCategoryEnum.Analytical,
                Model.ReportsCategoryEnum.Inventory,
                Model.ReportsCategoryEnum.Liabilities,
                Model.ReportsCategoryEnum.Memberships,
                Model.ReportsCategoryEnum.Products,
                Model.ReportsCategoryEnum.WalkIns
            ]
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, $q: ng.IQService, $states: ng.ui.IStateService, $rootScope: ng.IRootScopeService, private securityService: Meevo.Components.Common.ISecurityService, private $http: ng.IHttpService, identityService: Meevo.Components.Common.IdentityService, $modalService: Meevo.Components.Modal.IModalService, translate: angular.translate.ITranslateService, private businessInfoDataService: IBusinessInfoDataService, private $window: ng.IWindowService, private dataService: Meevo.Components.BaseClasses.IDataService) {
            this.routeNames = appSettings.ROUTE_NAMES;
            this.$q = $q;
            this.$states = $states;
            this.$rootScope = $rootScope;
            this.modalService = $modalService;

            this.identityService = identityService;

            this.states = $states.get();
            this.initializeConvoMap();
            this.$translate = translate;
            //$rootScope.$on(Meevo.Components.Common.Messages.MEEVO_FIELD_LABELS_SET, (event: angular.IAngularEvent, params: any) => {
            //    let response = params

            //});

        }

        /**
         * Initializes the convo map by mapping phrases to their corresponding route name.
         */
        private initializeConvoMap(): void {

            let convoMetadata = {
                home: new ConvoMetadata(this.routeNames.home, null),
                businessInfo: new ConvoMetadata(this.routeNames.businessInfo, this.securityKeys.DATA_BUSINESSINFO),
                businessType: new ConvoMetadata(this.routeNames.businessTypes, this.securityKeys.DATA_BUSINESSTYPE),
                cancellationReasons: new ConvoMetadata(this.routeNames.cancellationReasons, this.securityKeys.DATA_CANCELLATIONREASON),
                client: new ConvoMetadata(this.routeNames.client, this.securityKeys.DATA_CLIENT),
                clientClientType: new ConvoMetadata(this.routeNames.clientClientType, this.securityKeys.DATA_CLIENTCLIENTTYPE),
                locationGroups: new ConvoMetadata(this.routeNames.locationGroups, this.securityKeys.DATA_LOCATIONGROUP),
                location: new ConvoMetadata(this.routeNames.location, this.securityKeys.MANAGEMENT_LOCATION),
                locations: new ConvoMetadata(this.routeNames.location, this.securityKeys.MANAGEMENT_LOCATION),
                departments: new ConvoMetadata(this.routeNames.departments, this.securityKeys.DATA_DEPARTMENT),
                departmentGoal: new ConvoMetadata(this.routeNames.departmentGoal, this.securityKeys.GOALS_OVERALLDEPARTMENTGOALS),
                employeeGoal: new ConvoMetadata(this.routeNames.employeeGoal, this.securityKeys.GOALS_EMPLOYEEGOALS),
                dashboardGoals: new ConvoMetadata(this.routeNames.dashboardGoals, this.securityKeys.GOALS_GOALSDASHBOARD),
                distributors: new ConvoMetadata(this.routeNames.distributors, this.securityKeys.DATA_DISTRIBUTOR),
                drawer: new ConvoMetadata(this.routeNames.drawer, this.securityKeys.REGISTER_DRAWER),
                product: new ConvoMetadata(this.routeNames.product, this.securityKeys.DATA_PRODUCT),
                payInOutReasons: new ConvoMetadata(this.routeNames.payinoutreasons, this.securityKeys.REGISTER_PAYINOUTREASON),
                paymentType: new ConvoMetadata(this.routeNames.paymentType, this.securityKeys.DATA_PAYMENTTYPE),
                payroll: new ConvoMetadata(this.routeNames.payroll, this.securityKeys.MANAGEMENT_PAYROLL),
                manufacturers: new ConvoMetadata(this.routeNames.manufacturers, this.securityKeys.DATA_MANUFACTURER),
                employee: new ConvoMetadata(this.routeNames.employee, this.securityKeys.DATA_EMPLOYEE),
                teachers: new ConvoMetadata(this.routeNames.teachers, this.securityKeys.DATA_TEACHER),
                students: new ConvoMetadata(this.routeNames.student, this.securityKeys.DATA_STUDENT),
                employeeCategories: new ConvoMetadata(this.routeNames.employeeCategories, this.securityKeys.DATA_EMPLOYEECATEGORY),
                employeeTemplates: new ConvoMetadata(this.routeNames.employeeTemplates, this.securityKeys.DATA_EMPLOYEETEMPLATE),
                equipment: new ConvoMetadata(this.routeNames.equipment, this.securityKeys.DATA_EQUIPMENT),
                onlineBookingSettings: new ConvoMetadata(this.routeNames.onlineBookingSettings, this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS),
                floorLocation: new ConvoMetadata(this.routeNames.floorLocation, this.securityKeys.INVENTORY_FLOORLOCATION),
                employeeTemplatePromotions: new ConvoMetadata(this.routeNames.employeeTemplatePromotions, this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION),
                services: new ConvoMetadata(this.routeNames.services, this.securityKeys.DATA_SERVICE),
                addOnGroup: new ConvoMetadata(this.routeNames.addOnGroup, this.securityKeys.DATA_ADDONGROUP),
                serviceCategories: new ConvoMetadata(this.routeNames.serviceCategories, this.securityKeys.DATA_SERVICECATEGORY),
                meevoStore: new ConvoMetadata(this.routeNames.meevoStore, this.securityKeys.MEEVOSTORE_MEEVOSTORE),
                appointmentBook: new ConvoMetadata(this.routeNames.appointmentBook, this.securityKeys.APPOINTMENTS_APPOINTMENTBOOK),
                standingBlocks: new ConvoMetadata(this.routeNames.standingBlocks, this.securityKeys.APPOINTMENTS_BLOCKDEFINITION),
                standingAppointments: new ConvoMetadata(this.routeNames.standingAppointments, this.securityKeys.APPOINTMENTS_STANDINGDEFINITION),
                appointmentCategories: new ConvoMetadata(this.routeNames.appointmentCategories, this.securityKeys.DATA_APPOINTMENTCATEGORY),
                callCenter: new ConvoMetadata(this.routeNames.callCenter, this.securityKeys.APPOINTMENTS_CALLCENTERMANAGER),
                confirmationManager: new ConvoMetadata(this.routeNames.confirmationManager, this.securityKeys.APPOINTMENTS_CONFIRMATIONMANAGER),
                inventoryCount: new ConvoMetadata(this.routeNames.inventoryCount, this.securityKeys.INVENTORY_COUNT),
                miscSupplyDefinitions: new ConvoMetadata(this.routeNames.miscSupplyDefinitions, this.securityKeys.INVENTORY_MISCSUPPLYDEFINITIONS),
                employeeSupplyUsage: new ConvoMetadata(this.routeNames.employeeSupplyUsage, this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE),
                clientMerge: new ConvoMetadata(this.routeNames.clientMerge, this.securityKeys.MANAGEMENT_CLIENTMERGE),
                clientManualMerge: new ConvoMetadata(this.routeNames.clientManualMerge, this.securityKeys.MANAGEMENT_MANUALMERGECLIENTS),
                integrations: new ConvoMetadata(this.routeNames.integrations, this.securityKeys.MANAGEMENT_INTEGRATION),
                inventoryReturns: new ConvoMetadata(this.routeNames.inventoryReturns, this.securityKeys.INVENTORY_RETURNS),
                customBranding: new ConvoMetadata(this.routeNames.customBranding, this.securityKeys.MANAGEMENT_CUSTOMBRANDING),
                referralTypes: new ConvoMetadata(this.routeNames.referralTypes, this.securityKeys.DATA_REFERRALTYPE),
                giftCardTypes: new ConvoMetadata(this.routeNames.giftCardTypes, this.securityKeys.DATA_GIFTCARDTYPE),
                visitNoteTypes: new ConvoMetadata(this.routeNames.visitNoteTypes, this.securityKeys.DATA_VISITNOTETYPE),
                search: new ConvoMetadata(this.routeNames.search, null),
                itemDetail: new ConvoMetadata(this.routeNames.itemDetail, null),
                securityRoles: new ConvoMetadata(this.routeNames.securityRoles, this.securityKeys.MANAGEMENT_SECURITYROLE),
                securityRolesManager: new ConvoMetadata(this.routeNames.securityRolesManager, this.securityKeys.MANAGEMENT_SECURITYROLESMANAGER),
                clientPoint: new ConvoMetadata(this.routeNames.clientPoint, this.securityKeys.MANAGEMENT_CLIENTPOINT),
                blockTypes: new ConvoMetadata(this.routeNames.blockTypes, this.securityKeys.DATA_BLOCKTYPE),
                workActivities: new ConvoMetadata(this.routeNames.workActivities, this.securityKeys.DATA_WORKACTIVITY),
                packageTypes: new ConvoMetadata(this.routeNames.packageTypes, this.securityKeys.DATA_PACKAGETYPE),
                posHardware: new ConvoMetadata(this.routeNames.posHardware, this.securityKeys.REGISTER_POSHARDWARE),
                productCategories: new ConvoMetadata(this.routeNames.productCategories, this.securityKeys.DATA_PRODUCTCATEGORY),
                purchaseOrder: new ConvoMetadata(this.routeNames.purchaseOrder, this.securityKeys.INVENTORY_PURCHASEORDER),
                register: new ConvoMetadata(this.routeNames.register, this.securityKeys.REGISTER_REGISTER),
                discounts: new ConvoMetadata(this.routeNames.discounts, this.securityKeys.REGISTER_DISCOUNTS),
                markItemsOnSale: new ConvoMetadata(this.routeNames.saleProgram, this.securityKeys.REGISTER_SALEPROGRAM),
                resources: new ConvoMetadata(this.routeNames.resources, this.securityKeys.DATA_RESOURCE),
                resourceCategory: new ConvoMetadata(this.routeNames.resourceCategory, this.securityKeys.DATA_RESOURCECATEGORY),
                reports: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS),
                performanceDashboards: new ConvoMetadata(this.routeNames.performanceInsights, this.securityKeys.INSIGHTS),
                insightsUserManagement: new ConvoMetadata(this.routeNames.insightsUserManagement, this.securityKeys.INSIGHTS_USERMANAGEMENT),
                performanceInsightsSales: new ConvoMetadata(this.routeNames.performanceInsights, this.securityKeys.INSIGHTS_PERFORMANCE, {categoryId: Meevo.Model.ReportsCategoryEnum.Sales}),
                reportsAnalytical: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_ANALYTICAL, {categoryId: Meevo.Model.ReportsCategoryEnum.Analytical}),
                reportsAppointments: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_APPOINTMENTS, {categoryId: Meevo.Model.ReportsCategoryEnum.Appointments}),
                reportsClients: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_CLIENTS, {categoryId: Meevo.Model.ReportsCategoryEnum.Clients}),
                reportsEmployee: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_EMPLOYEE, {categoryId: Meevo.Model.ReportsCategoryEnum.Employee}),
                reportsFrontDesk: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_FRONTDESK, {categoryId: Meevo.Model.ReportsCategoryEnum.FrontDesk}),
                reportsInventory: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_INVENTORY, {categoryId: Meevo.Model.ReportsCategoryEnum.Inventory}),
                reportsLiabilities: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_LIABILITIES, {categoryId: Meevo.Model.ReportsCategoryEnum.Liabilities}),
                reportsMemberships: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_MEMBERSHIPS, {categoryId: Meevo.Model.ReportsCategoryEnum.Memberships}),
                reportsPayroll: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_PAYROLL, {categoryId: Meevo.Model.ReportsCategoryEnum.Payroll}),
                reportsProducts: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_PRODUCTS, {categoryId: Meevo.Model.ReportsCategoryEnum.Products}),
                reportsReferrals: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_REFERRALS, {categoryId: Meevo.Model.ReportsCategoryEnum.Referrals}),
                reportsRegister: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_REGISTERSALES, { categoryId: Meevo.Model.ReportsCategoryEnum.Register}),
                reportsSchedules: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_SCHEDULES, { categoryId: Meevo.Model.ReportsCategoryEnum.Schedules }),
                reportScheduler: new ConvoMetadata(this.routeNames.reportScheduler, this.securityKeys.MANAGEMENT_REPORTSCHEDULE),
                reportsWalkIns: new ConvoMetadata(this.routeNames.reports, this.securityKeys.REPORTS_WALKINS, {categoryId: Meevo.Model.ReportsCategoryEnum.WalkIns}),
                waitList: new ConvoMetadata(this.routeNames.waitList, this.securityKeys.APPOINTMENTS_WAITLIST),
                drawerManager: new ConvoMetadata(this.routeNames.drawerManager, this.securityKeys.REGISTER_DRAWERMANAGER),
                membershipTypes: new ConvoMetadata(this.routeNames.membershipTypes, this.securityKeys.MEMBERSHIP_MEMBERSHIPTYPE),
                memberships: new ConvoMetadata(this.routeNames.memberships, this.securityKeys.MEMBERSHIP_MEMBERSHIP),
                memberBenefitTemplates: new ConvoMetadata(this.routeNames.memberBenefitTemplates, this.securityKeys.MEMBERSHIP_MEMBERBENEFITTEMPLATE),
                membershipCancellation: new ConvoMetadata(this.routeNames.membershipCancellation, this.securityKeys.MEMBERSHIP_CANCELLATIONREASON),
                membershipManager: new ConvoMetadata(this.routeNames.membershipManager, this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER),
                eftControlPanel: new ConvoMetadata(this.routeNames.eftControlPanel, this.securityKeys.MEMBERSHIP_EFTCONTROLPANEL),
                swapGroups: new ConvoMetadata(this.routeNames.swapGroups, this.securityKeys.DATA_SWAPGROUP),
                ipRestrictions: new ConvoMetadata(this.routeNames.ipRestrictions, this.securityKeys.MANAGEMENT_IPRESTRICTION),
                marketPricing: new ConvoMetadata(this.routeNames.marketPricing, this.securityKeys.MANAGEMENT_MARKETPRICING),
                drawerHistory: new ConvoMetadata(this.routeNames.drawerHistory, this.securityKeys.REGISTER_DRAWERHISTORY),
                transactionEditor: new ConvoMetadata(this.routeNames.transactionEditor, this.securityKeys.REGISTER_TRANSACTIONEDITOR),
                merchantAccounts: new ConvoMetadata(this.routeNames.merchantAccounts, this.securityKeys.REGISTER_MERCHANTACCOUNT),
                holiday: new ConvoMetadata(this.routeNames.holiday, this.securityKeys.BUSINESSINFO_HOLIDAYS),
                notificationSetting: new ConvoMetadata(this.routeNames.notificationSetting, this.securityKeys.BUSINESSINFO_NOTIFICATIONS),
                notificationTemplates: new ConvoMetadata(this.routeNames.notificationTemplates, this.securityKeys.BUSINESSINFO_NOTIFICATIONTEMPLATE),
                tax: new ConvoMetadata(this.routeNames.tax, this.securityKeys.BUSINESSINFO_FINANCIAL),
                eventSchedules: new ConvoMetadata(this.routeNames.eventSchedules, this.securityKeys.BUSINESSINFO_EVENTSCHEDULE),
                compensationSettings: new ConvoMetadata(this.routeNames.compensationSettings, this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS),
                cultureSettings: new ConvoMetadata(this.routeNames.cultureSettings, this.securityKeys.BUSINESSINFO_CULTURESETTINGS),
                timeClock: new ConvoMetadata(this.routeNames.timeClock, this.securityKeys.SCHEDULES_TIMECLOCK),
                smartCenters: new ConvoMetadata(this.routeNames.smartCenters, this.securityKeys.DATA_SMARTCENTERDESIGNER),
                giftCardBalance: new ConvoMetadata(this.routeNames.giftCardBalance, this.securityKeys.REGISTER_REGISTER_GIFTCARDLOOKUP),
                giftCardIntegration: new ConvoMetadata(this.routeNames.giftCardIntegration, this.securityKeys.DATA_GIFTCARDINTEGRATION),
                activityLog: new ConvoMetadata(this.routeNames.activityLog, this.securityKeys.MANAGEMENT_ACTIVITYLOG),
                alertsManager: new ConvoMetadata(this.routeNames.alertsManager, this.securityKeys.MANAGEMENT_ALERTSMANAGER),
                alertsLog: new ConvoMetadata(this.routeNames.alertsLog, this.securityKeys.MANAGEMENT_ALERTSLOG),
                charts: new ConvoMetadata(this.routeNames.charts, this.securityKeys.MANAGEMENT_CHARTS, { interopParams: { isInterop: true, targetRoute: this.routeNames.charts.toLowerCase() } }),
                clientRecordManagement: new ConvoMetadata(this.routeNames.clientRecordManagement, this.securityKeys.MANAGEMENT_CLIENTRECORDMANAGEMENT, { interopParams: { isInterop: true, targetRoute: this.routeNames.clientRecordManagement.toLowerCase() } }),
                imageGalleryCategory: new ConvoMetadata(this.routeNames.imageGalleryCategory, this.securityKeys.DATA_IMAGEGALLERYCATEGORY),
                productBundles: new ConvoMetadata(this.routeNames.productBundles, this.securityKeys.DATA_PRODUCTBUNDLE),
                packageLookup: new ConvoMetadata(this.routeNames.packageLookup, this.securityKeys.DATA_PACKAGELOOKUP), // TODO: is this security key correct?
                stockLevels: new ConvoMetadata(this.routeNames.stockLevels, this.securityKeys.INVENTORY_STOCKLEVEL),
                walkinManager: new ConvoMetadata(this.routeNames.walkinManager, this.securityKeys.APPOINTMENTS_WALKINMANAGER),
                walkinManagerSettings: new ConvoMetadata(this.routeNames.walkinManagerSettings, this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS),
                walkinManagerDisplay: new ConvoMetadata(this.routeNames.walkinManagerDisplay, this.securityKeys.APPOINTMENTS_WALKINMANAGERDISPLAY),
                walkinManagerKiosk: new ConvoMetadata(this.routeNames.walkinManagerKiosk, this.securityKeys.APPOINTMENTS_WALKINMANAGERKIOSK),
                basicEmailMarketing: new ConvoMetadata(this.routeNames.basicEmailMarketing, this.securityKeys.MARKETING_BASICMARKETING),
                accountSync: new ConvoMetadata(this.routeNames.accountsync, this.securityKeys.INTEGRATION_QUICKBOOKS),
                quickbooksDesktop: new ConvoMetadata(this.routeNames.quickbooksDesktop, this.securityKeys.INTEGRATION_QUICKBOOKSDESKTOP),
                eGifts: new ConvoMetadata(this.routeNames.egifts, this.securityKeys.MANAGEMENT_EGIFT),
                shippingFees: new ConvoMetadata(this.routeNames.shippingFees, this.securityKeys.REGISTER_SHIPPINGFEES),
                paging: new ConvoMetadata(this.routeNames.paging, this.securityKeys.INTEGRATION_PAGING),
                pointPromotionCampaign: new ConvoMetadata(this.routeNames.pointPromotionCampaign, this.securityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN),
                fieldLabels: new ConvoMetadata(this.routeNames.fieldLabels, this.securityKeys.BUSINESSINFO_FIELDLABELS),
                docsAndForms: new ConvoMetadata(this.routeNames.docsAndForms, this.securityKeys.MANAGEMENT_DOCSANDFORMS),
                transworld: new ConvoMetadata(this.routeNames.transworld, this.securityKeys.INTEGRATION_TRANSWORLD),
                salesRankings: new ConvoMetadata(this.routeNames.salesRankings, this.securityKeys.MANAGEMENT_SALESRANKING),
                ratingsControlPanel: new ConvoMetadata(this.routeNames.ratingsControlPanel, this.securityKeys.MANAGEMENT_RATINGSCONTROLPANEL),
                techSphere: new ConvoMetadata(this.routeNames.techSphere, this.securityKeys.INTEGRATION_TRANSWORLD),
                meevoMessenger: new ConvoMetadata(this.routeNames.meevoMessenger, this.securityKeys.MANAGEMENT_MEEVOMESSENGER),
                meevoMessengerSettings: new ConvoMetadata(this.routeNames.meevoMessengerSettings, this.securityKeys.MANAGEMENT_MEEVOMESSENGER_MEEVOMESSENGERSETTINGS_ARRIVALSSETTINGS),
                textel: new ConvoMetadata(this.routeNames.meevoMessenger, this.securityKeys.INTEGRATION_TEXTEL),
                textelSettings: new ConvoMetadata(this.routeNames.meevoMessengerSettings, this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS, { initialEditSection: 'SECTION_TEXTEL' }),
                sms: new ConvoMetadata(this.routeNames.meevoMessenger, this.securityKeys.INTEGRATION_TWOWAYSMS),
                smsSettings: new ConvoMetadata(this.routeNames.meevoMessengerSettings, this.securityKeys.INTEGRATION_TWOWAYSMS_TAB_TWOWAYSMSSETTINGS, { initialEditSection: 'SECTION_TWO_WAY_SMS' }),
                textelBlast: new ConvoMetadata(this.routeNames.textelBlast, this.securityKeys.INTEGRATION_TEXTELMARKETING),
                servicesWizard: new ConvoMetadata(this.routeNames.servicesWizard, this.securityKeys.DATA_SERVICESWIZARD),
                clientIntake: new ConvoMetadata(this.routeNames.clientIntake, this.securityKeys.DATA_CLIENTINTAKEFORM),
                clientIntakeForm: new ConvoMetadata(this.routeNames.clientIntakeForm, this.securityKeys.MANAGEMENT_CLIENTINTAKEFORMBUILDER_TAB_FORMBUILDER),
                selfCheckInKiosk: new ConvoMetadata(this.routeNames.selfCheckInKiosk, this.securityKeys.APPOINTMENTS_SELFCHECKINKIOSK),
                selfCheckInKioskSettings: new ConvoMetadata(this.routeNames.selfCheckInKioskSettings, this.securityKeys.BUSINESSINFO_SELFCHECKINKIOSKSETTINGS),
                aveda: new ConvoMetadata(this.routeNames.aveda, this.securityKeys.INTEGRATION_AVEDA),
                employeeServiceTimesPricing: new ConvoMetadata(this.routeNames.employeeServiceTimesPricing, this.securityKeys.REGISTER_REGISTER_EMPLOYEESERVICETIMESPRICING),
                fiveStartRatingSettings: new ConvoMetadata(this.routeNames.fiveStarRatingSetting, this.securityKeys.BUSINESSINFO_FIVESTARRATINGSSETTINGS),
                serviceCharges: new ConvoMetadata(this.routeNames.serviceCharges, this.securityKeys.BUSINESSINFO_SERVICECHARGES),
                fameAdvantage: new ConvoMetadata(this.routeNames.fameAdvantage, this.securityKeys.INTEGRATION_FAMEADVANTAGE),
                productInfo: new ConvoMetadata(this.routeNames.productInfoModal, this.securityKeys.INVENTORY_PRODUCTMODAL),
                adpRunPayroll: new ConvoMetadata(this.routeNames.adpRunIntegration, this.securityKeys.INTEGRATION_ADPINTEGRATION),
                adpWfnPayroll: new ConvoMetadata(this.routeNames.adpWfnIntegration, this.securityKeys.INTEGRATION_ADPWFNINTEGRATION),
                adpWisely: new ConvoMetadata(this.routeNames.adpWiselyIntegration, this.securityKeys.INTEGRATION_ADPWISELYINTEGRATION),
                royaltyExport: new ConvoMetadata(this.routeNames.royaltyExport, this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS),
                emma: new ConvoMetadata(this.routeNames.emmaAccountSettings, this.securityKeys.MARKETING_EMMA),
                yieldManagementStrategy: new ConvoMetadata(this.routeNames.yieldManagementStrategy, this.securityKeys.MANAGEMENT_YIELDMANAGEMENTSTRATEGY),
                yieldManagementProgram: new ConvoMetadata(this.routeNames.yieldManagementProgram, this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM),
                onlinePresenceManagement: new ConvoMetadata(this.routeNames.onlinePresenceManagement, this.securityKeys.MARKETING_ONLINEPRESENCEMANAGEMENT),
                onlinePresenceSettings: new ConvoMetadata(this.routeNames.onlinePresenceSettings, this.securityKeys.MARKETING_ONLINEPRESENCESETTINGS),
                systemToolbox: new ConvoMetadata(this.routeNames.systemToolbox, this.securityKeys.BUSINESSINFO_SYSTEMTOOLBOX),
                meevoTheming: new ConvoMetadata(this.routeNames.meevoTheming, this.securityKeys.MANAGEMENT_MEEVOTHEMING),
                meevoFacebookGroup: new ConvoMetadata(this.routeNames.meevoFacebook, this.securityKeys.HELP_MEEVOFACEBOOKGROUP, {}, () => {
                    return this.businessInfoDataService
                        .getBusinessInfoPreferences()
                        .then((busInfo) => {
                            return busInfo.helpSectionSettings.meevoFacebookGroupUrl;

                        });
                }),
                inventoryTransfer: new ConvoMetadata(this.routeNames.inventoryTransfer, this.securityKeys.INVENTORY_TRANSFER),
                clientApp: new ConvoMetadata(this.routeNames.clientApp, this.securityKeys.INTEGRATION_CLIENTAPP),
                usageReasons: new ConvoMetadata(this.routeNames.usageReasons, this.securityKeys.INVENTORY_USAGEREASON),
                tippy: new ConvoMetadata(this.routeNames.tippy, this.securityKeys.INTEGRATION_TIPPY),
                userDefinedControls: new ConvoMetadata(this.routeNames.userDefinedControls, this.securityKeys.DATA_USERDEFINEDCONTROLS),
                merchantOnboardingTesting: new ConvoMetadata(this.routeNames.merchantOnboardingTesting, null),

                /*  Interop ConvoMetadata    */
                advancedCustomBranding: new ConvoMetadata(this.routeNames.advancedCustomBranding, this.securityKeys.MANAGEMENT_CUSTOMBRANDING, { interopParams: { isInterop: true, targetRoute: this.routeNames.advancedCustomBranding } }),
                businessPreferences: new ConvoMetadata(this.routeNames.businessPreferences, this.securityKeys.DATA_BUSINESSINFO_TAB_PREFERENCES, { interopParams: { isInterop: true, targetRoute: this.routeNames.businessPreferences } }),
                csvExport: new ConvoMetadata(this.routeNames.csvExport, this.securityKeys.CSVEXPORT, { interopParams: { isInterop: true, targetRoute: this.routeNames.csvExport } }),
                myMeevoApp: new ConvoMetadata(this.routeNames.myMeevoApp, this.securityKeys.INTEGRATION_MYMEEVOAPP, { interopParams: { isInterop: true, targetRoute: this.routeNames.myMeevoApp } }),
                //routeNames.newFormBuilder
                meevoPay: new ConvoMetadata(this.routeNames.meevoPay, this.securityKeys.MEEVOPAY, { interopParams: { isInterop: true, targetRoute: this.routeNames.meevoPay } }),
                onlineMembershipSettings: new ConvoMetadata(this.routeNames.onlineMembershipSettings, this.securityKeys.MEMBERSHIP_ONLINEMEMBERSHIPSETTINGS, { interopParams: { isInterop: true, targetRoute: this.routeNames.onlineMembershipSettings } }),
                paymentPlans: new ConvoMetadata(this.routeNames.paymentPlans, this.securityKeys.MANAGEMENT_PAYMENTPLANMANAGER, { interopParams: { isInterop: true, targetRoute: this.routeNames.paymentPlans } }),
                paymentRequests: new ConvoMetadata(this.routeNames.paymentRequests, null, { interopParams: { isInterop: true, targetRoute: this.routeNames.paymentRequests } }),
                pbiDashboards: new ConvoMetadata(this.routeNames.pbiDashboards, this.securityKeys.POWERBIDASHBOARDS_DATAGROUP, { interopParams: { isInterop: true, targetRoute: this.routeNames.pbiDashboards } }),
                productBulkUpdate: new ConvoMetadata(this.routeNames.productBulkUpdate, this.securityKeys.DATA_PRODUCTBULKUPDATE, { interopParams: { isInterop: true, targetRoute: this.routeNames.productBulkUpdate } }),
                salonInteractive: new ConvoMetadata(this.routeNames.salonInteractive, this.securityKeys.INTEGRATION_SALONINTERACTIVE, { interopParams: { isInterop: true, targetRoute: this.routeNames.salonInteractive } }),
                schedulesManager: new ConvoMetadata(this.routeNames.schedulesManager, this.securityKeys.SCHEDULES_CALENDAR, { interopParams: { isInterop: true, targetRoute: this.routeNames.schedulesManager } }),
                timeOffRequests: new ConvoMetadata(this.routeNames.timeOffRequests, this.securityKeys.MANAGEMENT_TIMEOFFREQUESTS, { interopParams: { isInterop: true, targetRoute: this.routeNames.timeOffRequests } }),
                twoWaySmsOnboarding: new ConvoMetadata(this.routeNames.twoWaySmsOnboarding, this.securityKeys.BUSINESSINFO_TWOWAYSMSONBOARDING, { interopParams: { isInterop: true, targetRoute: this.routeNames.twoWaySmsOnboarding } }),
                zapier: new ConvoMetadata(this.routeNames.zapier, this.securityKeys.INTEGRATION_ZAPIER, { interopParams: { isInterop: true, targetRoute: this.routeNames.zapier } }),
                bulkLiabilityUpdate: new ConvoMetadata(this.routeNames.bulkLiabilityUpdate, this.securityKeys.MANAGEMENT_BULKLIABILITYUPDATE, { interopParams: { isInterop: true, targetRoute: this.routeNames.bulkLiabilityUpdate } }),
                bulkLiabilityTransfer: new ConvoMetadata(this.routeNames.bulkLiabilityTransfer, this.securityKeys.MANAGEMENT_BULKLIABILITYTRANSFER, { interopParams: { isInterop: true, targetRoute: this.routeNames.bulkLiabilityTransfer } }),
                chartPhrases: new ConvoMetadata(this.routeNames.chartPhrases, this.securityKeys.MANAGEMENT_CHARTSPHRASES),
                upsellOpportunities: new ConvoMetadata(this.routeNames.upsellOpportunities, this.securityKeys.UPSELLOPPORTUNITIES),
                aiReceptionist: new ConvoMetadata(this.routeNames.aiReceptionist, this.securityKeys.MANAGEMENT_AIRECEPTIONIST),
            };

            this.convoMap = {
                'home': convoMetadata.home,

                'businfo': convoMetadata.businessInfo,
                'bustype': convoMetadata.businessType,
                'bustypes': convoMetadata.businessType,
                'businesstype': convoMetadata.businessType,
                'businesstypes': convoMetadata.businessType,

                'cancellationreason': convoMetadata.cancellationReasons,
                'cancellationreasons': convoMetadata.cancellationReasons,
                'cancelreason': convoMetadata.cancellationReasons,
                'cancelreasons': convoMetadata.cancellationReasons,

                'client': convoMetadata.client,
                'clients': convoMetadata.client,

                'clienttype': convoMetadata.clientClientType,
                'clienttypes': convoMetadata.clientClientType,

                'docsandforms': convoMetadata.docsAndForms,
                'docsforms': convoMetadata.docsAndForms,
                'docs': convoMetadata.docsAndForms,
                'fbgroup': convoMetadata.meevoFacebookGroup,
                'forms': convoMetadata.docsAndForms,
                'form': convoMetadata.docsAndForms,

                'locationgroups': convoMetadata.locationGroups,
                'locationgroup': convoMetadata.locationGroups,
                'locgroup': convoMetadata.locationGroups,
                'locgroups': convoMetadata.locationGroups,

                'location': convoMetadata.location,
                'locations': convoMetadata.location,

                'department': convoMetadata.departments,
                'departments': convoMetadata.departments,

                'departmentgoals': convoMetadata.departmentGoal,
                'overallgoals': convoMetadata.departmentGoal,
                'overallgoal': convoMetadata.departmentGoal,
                'deptgoal': convoMetadata.departmentGoal,
                'deptgoals': convoMetadata.departmentGoal,
                'departmentgoal': convoMetadata.departmentGoal,
                'busgoals': convoMetadata.departmentGoal,
                'busgoal': convoMetadata.departmentGoal,
                'businessgoals': convoMetadata.departmentGoal,
                'businessgoal': convoMetadata.departmentGoal,

                'employeegoal': convoMetadata.employeeGoal,
                'employeegoals': convoMetadata.employeeGoal,
                'empgoal': convoMetadata.employeeGoal,
                'empgoals': convoMetadata.employeeGoal,

                'goalsdashboard': convoMetadata.dashboardGoals,
                'goaldashboard': convoMetadata.dashboardGoals,
                'gdb': convoMetadata.dashboardGoals,
                'goaldash': convoMetadata.dashboardGoals,
                'goalsdash': convoMetadata.dashboardGoals,
                'goaldb': convoMetadata.dashboardGoals,
                'goalsdb': convoMetadata.dashboardGoals,
                'goaldashboards': convoMetadata.dashboardGoals,
                'goalsdashboards': convoMetadata.dashboardGoals,

                'distributor': convoMetadata.distributors,
                'distributors': convoMetadata.distributors,

                'drawer': convoMetadata.drawer,
                'drawers': convoMetadata.drawer,

                'product': convoMetadata.product,
                'products': convoMetadata.product,

                'productbulkupdate': convoMetadata.productBulkUpdate,
                'productbu': convoMetadata.productBulkUpdate,
                'pbu': convoMetadata.productBulkUpdate,

                'payinreason': convoMetadata.payInOutReasons,
                'payoutreason': convoMetadata.payInOutReasons,
                'payinreasons': convoMetadata.payInOutReasons,
                'payoutreasons': convoMetadata.payInOutReasons,

                'paymenttype': convoMetadata.paymentType,
                'paymenttypes': convoMetadata.paymentType,
                'paytype': convoMetadata.paymentType,
                'paytypes': convoMetadata.paymentType,

                'payroll': convoMetadata.payroll,

                'manufacturer': convoMetadata.manufacturers,
                'manufacturers': convoMetadata.manufacturers,

                'emp': convoMetadata.employee,
                'emps': convoMetadata.employee,
                'employee': convoMetadata.employee,
                'employees': convoMetadata.employee,

                'teacher': convoMetadata.teachers,
                'teachers': convoMetadata.teachers,

                'student': convoMetadata.students,
                'students': convoMetadata.students,

                'empcat': convoMetadata.employeeCategories,
                'empcats': convoMetadata.employeeCategories,

                'emptemp': convoMetadata.employeeTemplates,
                'emptemps': convoMetadata.employeeTemplates,
                'emptemplate': convoMetadata.employeeTemplates,
                'emptemplates': convoMetadata.employeeTemplates,
                'employeetemplate': convoMetadata.employeeTemplates,
                'employeetemplates': convoMetadata.employeeTemplates,

                'equipment': convoMetadata.equipment,

                'online': convoMetadata.onlineBookingSettings,
                'onlinebooking': convoMetadata.onlineBookingSettings,

                'floorloc': convoMetadata.floorLocation,
                'floorlocs': convoMetadata.floorLocation,
                'floorlocation': convoMetadata.floorLocation,
                'floorlocations': convoMetadata.floorLocation,

                'promo': convoMetadata.employeeTemplatePromotions,
                'promos': convoMetadata.employeeTemplatePromotions,
                'promotion': convoMetadata.employeeTemplatePromotions,
                'promotions': convoMetadata.employeeTemplatePromotions,

                'service': convoMetadata.services,
                'services': convoMetadata.services,

                'serviceaddon': convoMetadata.addOnGroup,
                'serviceaddons': convoMetadata.addOnGroup,

                'servicecat': convoMetadata.serviceCategories,
                'servicecats': convoMetadata.serviceCategories,
                'servicecategories': convoMetadata.serviceCategories,
                'servicecategory': convoMetadata.serviceCategories,

                'xchange': convoMetadata.meevoStore,
                'meevoexchange': convoMetadata.meevoStore,
                'store': convoMetadata.meevoStore,
                'meevostore': convoMetadata.meevoStore,

                'appointment': convoMetadata.appointmentBook,
                'appointment book': convoMetadata.appointmentBook,
                'appointmentbook': convoMetadata.appointmentBook,
                'my appointments': convoMetadata.appointmentBook,
                //US75037: Let server-side resolve these two keywords
                //'today': convoMetadata.appointmentBook,
                //'tomorrow': convoMetadata.appointmentBook,
                'book': convoMetadata.appointmentBook,

                'apptcat': convoMetadata.appointmentCategories,
                'apptcats': convoMetadata.appointmentCategories,
                'appointcat': convoMetadata.appointmentCategories,
                'appointcats': convoMetadata.appointmentCategories,
                'appointmentcat': convoMetadata.appointmentCategories,
                'appointmentcats': convoMetadata.appointmentCategories,

                'stand': convoMetadata.standingAppointments,
                'standing': convoMetadata.standingAppointments,
                'standings': convoMetadata.standingAppointments,
                'standingappt': convoMetadata.standingAppointments,
                'standingappts': convoMetadata.standingAppointments,
                'standingappointment': convoMetadata.standingAppointments,
                'standingappointments': convoMetadata.standingAppointments,

                'standblock': convoMetadata.standingBlocks,
                'standblocks': convoMetadata.standingBlocks,
                'standingblock': convoMetadata.standingBlocks,
                'standingblocks': convoMetadata.standingBlocks,

                'bookingagent': convoMetadata.callCenter,
                'callcenter': convoMetadata.callCenter,
                'callcentre': convoMetadata.callCenter,

                'schedules': convoMetadata.schedulesManager,
                'sched': convoMetadata.schedulesManager,
                'rosters': convoMetadata.schedulesManager,
                'roster': convoMetadata.schedulesManager,

                'confirmation': convoMetadata.confirmationManager,
                'confirmations': convoMetadata.confirmationManager,

                'count': convoMetadata.inventoryCount,

                'counts': convoMetadata.inventoryCount,
                'inventorycount': convoMetadata.inventoryCount,
                'inventorycounts': convoMetadata.inventoryCount,
                'invcount': convoMetadata.inventoryCount,
                'invcounts': convoMetadata.inventoryCount,

                'miscsupplies': convoMetadata.miscSupplyDefinitions,
                'miscsupply': convoMetadata.miscSupplyDefinitions,
                'miscellaneoussupply': convoMetadata.miscSupplyDefinitions,
                'miscellaneoussupplies': convoMetadata.miscSupplyDefinitions,
                'misc': convoMetadata.miscSupplyDefinitions,
                'supplies': convoMetadata.employeeSupplyUsage,
                'supply': convoMetadata.employeeSupplyUsage,
                'employee supply': convoMetadata.employeeSupplyUsage,
                'employee supply usage': convoMetadata.employeeSupplyUsage,
                'backbar': convoMetadata.employeeSupplyUsage,
                'back bar': convoMetadata.employeeSupplyUsage,

                'clientmerge': convoMetadata.clientMerge,
                'merge': convoMetadata.clientMerge,
                'intellimerge': convoMetadata.clientMerge,

                'manualmerge': convoMetadata.clientManualMerge,
                'manualmergeclients': convoMetadata.clientManualMerge,

                'integration': convoMetadata.integrations,
                'integrations': convoMetadata.integrations,

                'inventoryreturn': convoMetadata.inventoryReturns,
                'invreturn': convoMetadata.inventoryReturns,

                'brand': convoMetadata.customBranding,
                'branding': convoMetadata.customBranding,
                'custombranding': convoMetadata.customBranding,

                'referraltype': convoMetadata.referralTypes,

                'gctype': convoMetadata.giftCardTypes,
                'gctypes': convoMetadata.giftCardTypes,
                'giftcardtype': convoMetadata.giftCardTypes,
                'giftcardtypes': convoMetadata.giftCardTypes,

                'visitnotetype': convoMetadata.visitNoteTypes,
                'visitnotetypes': convoMetadata.visitNoteTypes,

                //'controls': new ConvoMetadata(this.routeNames.controlGallery, null),
                //'control': new ConvoMetadata(this.routeNames.controlGallery, null),
                //'controlgallery': new ConvoMetadata(this.routeNames.controlGallery, null),
                //'control gallery': new ConvoMetadata(this.routeNames.controlGallery, null),

                //'styles': new ConvoMetadata(this.routeNames.styleGallery, null),
                //'style': new ConvoMetadata(this.routeNames.styleGallery, null),
                //'stylegallery': new ConvoMetadata(this.routeNames.styleGallery, null),
                //'style gallery': new ConvoMetadata(this.routeNames.styleGallery, null),

                'search': convoMetadata.search,

                'item': convoMetadata.itemDetail,

                //'i18n': new ConvoMetadata(this.routeNames.localizationTest, null),
                //'localization': new ConvoMetadata(this.routeNames.localizationTest, null),

                'securityroles': convoMetadata.securityRoles,
                'security': convoMetadata.securityRolesManager,
                'securityadmin': convoMetadata.securityRolesManager,
                'securityadministration': convoMetadata.securityRolesManager,

                'clientpoint': convoMetadata.clientPoint,
                'clientpoints': convoMetadata.clientPoint,
                'clientpointsmanager': convoMetadata.clientPoint,

                'blocktype': convoMetadata.blockTypes,
                'blocktypes': convoMetadata.blockTypes,

                'workactivity': convoMetadata.workActivities,
                'workactivities': convoMetadata.workActivities,

                'pkg': convoMetadata.packageTypes,
                'pkgs': convoMetadata.packageTypes,
                'package': convoMetadata.packageTypes,
                'packages': convoMetadata.packageTypes,

                'poshardware': convoMetadata.posHardware,

                'productcat': convoMetadata.productCategories,
                'productcats': convoMetadata.productCategories,
                'productcategory': convoMetadata.productCategories,
                'productcategories': convoMetadata.productCategories,

                'purchaseorder': convoMetadata.purchaseOrder,
                'purchaseorders': convoMetadata.purchaseOrder,
                'po': convoMetadata.purchaseOrder,

                'register': convoMetadata.register,

                'discounts': convoMetadata.discounts,
                'discount': convoMetadata.discounts,

                'markitemsonsale': convoMetadata.markItemsOnSale,

                'resource': convoMetadata.resources,
                'resources': convoMetadata.resources,

                'resourcecat': convoMetadata.resourceCategory,
                'resourcecats': convoMetadata.resourceCategory,

                'reports': convoMetadata.reports,

                'performancedashboards': convoMetadata.performanceDashboards,
                'insightsusermanagement': convoMetadata.insightsUserManagement,
                'insightusermanagement': convoMetadata.insightsUserManagement,
                'insightsusers': convoMetadata.insightsUserManagement,

                'analyticalreports': convoMetadata.reportsAnalytical,
                'analyticalrpts': convoMetadata.reportsAnalytical,
                'analyticalreport': convoMetadata.reportsAnalytical,

                'appointmentreports': convoMetadata.reportsAppointments,
                'appointmentreport': convoMetadata.reportsAppointments,
                'appointmentrpts': convoMetadata.reportsAppointments,
                'appointmentrpt': convoMetadata.reportsAppointments,
                'apptreports': convoMetadata.reportsAppointments,
                'apptreport': convoMetadata.reportsAppointments,
                'apptrpts': convoMetadata.reportsAppointments,
                'apptrpt': convoMetadata.reportsAppointments,
                'appointreports': convoMetadata.reportsAppointments,
                'appointreport': convoMetadata.reportsAppointments,
                'appointrpts': convoMetadata.reportsAppointments,
                'appointrpt': convoMetadata.reportsAppointments,

                'clientreports': convoMetadata.reportsClients,
                'clientreport': convoMetadata.reportsClients,
                'clientrpts': convoMetadata.reportsClients,
                'clientrpt': convoMetadata.reportsClients,

                'employeereports': convoMetadata.reportsEmployee,
                'employeereport': convoMetadata.reportsEmployee,
                'employeerpts': convoMetadata.reportsEmployee,
                'employeerpt': convoMetadata.reportsEmployee,
                'empreports': convoMetadata.reportsEmployee,
                'empreport': convoMetadata.reportsEmployee,
                'emprpts': convoMetadata.reportsEmployee,
                'emprpt': convoMetadata.reportsEmployee,

                'frontdeskreports': convoMetadata.reportsFrontDesk,
                'frontdeskreport': convoMetadata.reportsFrontDesk,
                'frontdeskrpts': convoMetadata.reportsFrontDesk,
                'frontdeskrpt': convoMetadata.reportsFrontDesk,
                'fdreports': convoMetadata.reportsFrontDesk,
                'fdreport': convoMetadata.reportsFrontDesk,
                'fdrpts': convoMetadata.reportsFrontDesk,
                'fdrpt': convoMetadata.reportsFrontDesk,

                'inventoryreports': convoMetadata.reportsInventory,
                'inventoryreport': convoMetadata.reportsInventory,
                'inventoryrpts': convoMetadata.reportsInventory,
                'inventoryrpt': convoMetadata.reportsInventory,

                'liabilityreports': convoMetadata.reportsLiabilities,
                'liabilityreport': convoMetadata.reportsLiabilities,
                'liabilitiesreports': convoMetadata.reportsLiabilities,
                'liabilitiesreport': convoMetadata.reportsLiabilities,

                'membershipreports': convoMetadata.reportsMemberships,
                'membershipreport': convoMetadata.reportsMemberships,
                'membershiprpts': convoMetadata.reportsMemberships,
                'membershiprpt': convoMetadata.reportsMemberships,
                'memreports': convoMetadata.reportsMemberships,
                'memreport': convoMetadata.reportsMemberships,
                'memrpts': convoMetadata.reportsMemberships,
                'memrpt': convoMetadata.reportsMemberships,

                'payrollreports': convoMetadata.reportsPayroll,
                'payrollreport': convoMetadata.reportsPayroll,
                'payrollrpts': convoMetadata.reportsPayroll,
                'payrollrpt': convoMetadata.reportsPayroll,

                'productreports': convoMetadata.reportsProducts,
                'productreport': convoMetadata.reportsProducts,
                'productrpts': convoMetadata.reportsProducts,
                'productrpt': convoMetadata.reportsProducts,

                'referralreports': convoMetadata.reportsReferrals,
                'referralreport': convoMetadata.reportsReferrals,
                'referralrpts': convoMetadata.reportsReferrals,
                'referralrpt': convoMetadata.reportsReferrals,

                'registerreports': convoMetadata.reportsRegister,
                'registerreport': convoMetadata.reportsRegister,
                'registerrpts': convoMetadata.reportsRegister,
                'registerrpt': convoMetadata.reportsRegister,

                'schedulereports': convoMetadata.reportsSchedules,
                'schedulereport': convoMetadata.reportsSchedules,
                'schedulerpts': convoMetadata.reportsSchedules,
                'schedulerpt': convoMetadata.reportsSchedules,

                'reportscheduler': convoMetadata.reportScheduler,
                'reportsscheduler': convoMetadata.reportScheduler,
                'reportsched': convoMetadata.reportScheduler,
                'reportssched': convoMetadata.reportScheduler,
                'rptscheduler': convoMetadata.reportScheduler,
                'rptsscheduler': convoMetadata.reportScheduler,
                'rptsched': convoMetadata.reportScheduler,
                'rptssched': convoMetadata.reportScheduler,
                'scheduledreport': convoMetadata.reportScheduler,
                'scheduledreports': convoMetadata.reportScheduler,
                'schedreport': convoMetadata.reportScheduler,
                'schedreports': convoMetadata.reportScheduler,

                'walkinreports': convoMetadata.reportsWalkIns,
                'walkinreport': convoMetadata.reportsWalkIns,
                'walkinrpts': convoMetadata.reportsWalkIns,
                'walkinrpt': convoMetadata.reportsWalkIns,

                'wait': convoMetadata.waitList,
                'waitlist': convoMetadata.waitList,
                'waitlists': convoMetadata.waitList,
                'pending': convoMetadata.waitList, 

                'drawermanager': convoMetadata.drawerManager,

                'membertypes': convoMetadata.membershipTypes,
                'membershiptype': convoMetadata.membershipTypes,
                'membertype': convoMetadata.membershipTypes,
                'membershiptypes': convoMetadata.membershipTypes,

                'membership': convoMetadata.memberships,
                'memberships': convoMetadata.memberships,

                'memberbenefit': convoMetadata.memberBenefitTemplates,
                'memberbenefits': convoMetadata.memberBenefitTemplates,
                'memberbenefittemplate': convoMetadata.memberBenefitTemplates,
                'memberbenefittemplates': convoMetadata.memberBenefitTemplates,

                'membershipcancellationreason': convoMetadata.membershipCancellation,
                'membershipcancellationreasons': convoMetadata.membershipCancellation,
                'membershipcancelreason': convoMetadata.membershipCancellation,
                'membershipcancelreasons': convoMetadata.membershipCancellation,

                'memmanager': convoMetadata.membershipManager,
                'membershipmanager': convoMetadata.membershipManager,
                'mm': convoMetadata.membershipManager,

                'eftcontrolpanel': convoMetadata.eftControlPanel,

                'swap': convoMetadata.swapGroups,
                'swaps': convoMetadata.swapGroups,
                'swapgroups': convoMetadata.swapGroups,
                'swapgroup': convoMetadata.swapGroups,

                'iprestrict': convoMetadata.ipRestrictions,
                'iprestriction': convoMetadata.ipRestrictions,
                'iprestrictions': convoMetadata.ipRestrictions,

                'pricemanagement': convoMetadata.marketPricing,
                'marketpricing': convoMetadata.marketPricing,
                'market': convoMetadata.marketPricing,

                'drawerhist': convoMetadata.drawerHistory,
                'drawerhistory': convoMetadata.drawerHistory,

                'transeditor': convoMetadata.transactionEditor,
                'transacteditor': convoMetadata.transactionEditor,

                'merchacct': convoMetadata.merchantAccounts,
                'merchantacct': convoMetadata.merchantAccounts,
                'merchantaccount': convoMetadata.merchantAccounts,
                'merchantaccounts': convoMetadata.merchantAccounts,

                'holiday': convoMetadata.holiday,
                'holidays': convoMetadata.holiday,

                'notification': convoMetadata.notificationSetting,
                'notifications': convoMetadata.notificationSetting,

                'notificationtemplate': convoMetadata.notificationTemplates,
                'notificationtemp': convoMetadata.notificationTemplates,
                'notiftemp': convoMetadata.notificationTemplates,
                'notemp': convoMetadata.notificationTemplates,
                'notificationtemplates': convoMetadata.notificationTemplates,
                'notificationtemps': convoMetadata.notificationTemplates,
                'notiftemps': convoMetadata.notificationTemplates,
                'notemps': convoMetadata.notificationTemplates,

                'tax': convoMetadata.tax,
                'taxes': convoMetadata.tax,
                'currency': convoMetadata.tax,

                'event': convoMetadata.eventSchedules,
                'events': convoMetadata.eventSchedules,

                'payrollsettings': convoMetadata.compensationSettings,
                'multilocationpayroll': convoMetadata.compensationSettings,
                'multilocationpayrollsetting': convoMetadata.compensationSettings,
                'multilocationpayrollsettings': convoMetadata.compensationSettings,
                'multilocpayroll': convoMetadata.compensationSettings,
                'multilocpayrollsetting': convoMetadata.compensationSettings,
                'multilocpayrollsettings': convoMetadata.compensationSettings,
                'mlpayroll': convoMetadata.compensationSettings,
                'mlpayrollsetting': convoMetadata.compensationSettings,
                'mlpayrollsettings': convoMetadata.compensationSettings,

                'culture': convoMetadata.cultureSettings,

                'fields': convoMetadata.fieldLabels,
                'fieldlabels': convoMetadata.fieldLabels,
                'labels': convoMetadata.fieldLabels,
                'timeclock': convoMetadata.timeClock,

                'smartcenter': convoMetadata.smartCenters,
                'smartcenters': convoMetadata.smartCenters,
                'smart center': convoMetadata.smartCenters,
                'smart centers': convoMetadata.smartCenters,

                'smartcentre': convoMetadata.smartCenters,
                'smartcentres': convoMetadata.smartCenters,
                'smart centre': convoMetadata.smartCenters,
                'smart centres': convoMetadata.smartCenters,

                //'gc': convoMetadata.giftCardBalance,
                'gcbal': convoMetadata.giftCardBalance,

                'gcint': convoMetadata.giftCardIntegration,
                'giftcardintegration': convoMetadata.giftCardIntegration,
                'gift card integration': convoMetadata.giftCardIntegration,

                'activity': convoMetadata.activityLog,
                'activitylog': convoMetadata.activityLog,

                'alerts': convoMetadata.alertsManager,
                'alertsmanager': convoMetadata.alertsManager,

                'alertlog': convoMetadata.alertsLog,
                'alertslog': convoMetadata.alertsLog,

                'charts': convoMetadata.charts,
                'chart': convoMetadata.charts,

                'clientrecords': convoMetadata.clientRecordManagement,
                'clientrecord': convoMetadata.clientRecordManagement,
                'clientrecordmanagement': convoMetadata.clientRecordManagement,
                'clientrecordmgmt': convoMetadata.clientRecordManagement,

                'gallerycategory': convoMetadata.imageGalleryCategory,
                'gallerycategories': convoMetadata.imageGalleryCategory,
                'imagegallerycategory': convoMetadata.imageGalleryCategory,
                'imagegallerycategories': convoMetadata.imageGalleryCategory,
                'gallerycat': convoMetadata.imageGalleryCategory,

                'productbundle': convoMetadata.productBundles,
                'productbundles': convoMetadata.productBundles,
                'bundle': convoMetadata.productBundles,
                'bundles': convoMetadata.productBundles,

                'pkglookup': convoMetadata.packageLookup,
                'packagelookup': convoMetadata.packageLookup,

                'stocklevels': convoMetadata.stockLevels,
                'walkinmanagersettings': convoMetadata.walkinManagerSettings,

                'clientselection': convoMetadata.basicEmailMarketing,
                'export': convoMetadata.basicEmailMarketing,
                'clientexport': convoMetadata.basicEmailMarketing,
                'clientselectionexport': convoMetadata.basicEmailMarketing,

                'quickbooks': convoMetadata.accountSync,
                'quickbooksdesktop': convoMetadata.quickbooksDesktop,
                'qbdesktop': convoMetadata.quickbooksDesktop,
                'qbd': convoMetadata.quickbooksDesktop,
                'egift': convoMetadata.eGifts,

                'shippingfees': convoMetadata.shippingFees,
                'shippingfee': convoMetadata.shippingFees,

                'transworld': convoMetadata.transworld,

                'meevomessenger': convoMetadata.meevoMessenger,
                'messenger': convoMetadata.meevoMessenger,
                'msg': convoMetadata.meevoMessenger,
                'textel': convoMetadata.meevoMessenger,
                'capacity': convoMetadata.meevoMessenger,
                'arrival': convoMetadata.meevoMessenger,
                'arrivals': convoMetadata.meevoMessenger,
                'sms': convoMetadata.sms,
                'meevomessengersettings': convoMetadata.meevoMessengerSettings,
                'messengersettings': convoMetadata.meevoMessengerSettings,
                'msgsettings': convoMetadata.meevoMessengerSettings,
                'textelsettings': convoMetadata.textelSettings,
                'smssettings': convoMetadata.smsSettings,

                'smsonboarding': convoMetadata.twoWaySmsOnboarding,
                '2waysmsonboarding': convoMetadata.twoWaySmsOnboarding,

                'textelblast': convoMetadata.textelBlast,
                'paging': convoMetadata.paging,
                'walkinmanager': convoMetadata.walkinManager,
                'walkinmanagerdisplay': convoMetadata.walkinManagerDisplay,
                'walkinmanagerkiosk': convoMetadata.walkinManagerKiosk,

                'clientpointpromo': convoMetadata.pointPromotionCampaign,
                'clientpointpromos': convoMetadata.pointPromotionCampaign,
                'clientpointpromotion': convoMetadata.pointPromotionCampaign,
                'clientpointpromotions': convoMetadata.pointPromotionCampaign,

                'salesrankings': convoMetadata.salesRankings,
                'rankings': convoMetadata.salesRankings,
                'salesranking': convoMetadata.salesRankings,
                'salesrankingexport': convoMetadata.salesRankings,
                'salesrankingsexport': convoMetadata.salesRankings,
                'ranking': convoMetadata.salesRankings,

                'rating': convoMetadata.ratingsControlPanel,
                'ratings': convoMetadata.ratingsControlPanel,
                'ratingscontrolpanel': convoMetadata.ratingsControlPanel,
                'techsphere': convoMetadata.techSphere,
                'tech': convoMetadata.techSphere,
                'serviceswizard':convoMetadata.servicesWizard,

                'intake': convoMetadata.clientIntake,
                'intakeform': convoMetadata.clientIntake,
                'clientintake': convoMetadata.clientIntake,
                'cif': convoMetadata.clientIntake,

                'clientintakeformbuilder': convoMetadata.clientIntakeForm,
                'intakeformbuilder': convoMetadata.clientIntakeForm,
                'cifbuilder': convoMetadata.clientIntakeForm,
                'cifb': convoMetadata.clientIntakeForm,

                'check-inkiosk': convoMetadata.selfCheckInKiosk,
                'checkin': convoMetadata.selfCheckInKiosk,
                'check-in': convoMetadata.selfCheckInKiosk,
                'selfcheckin': convoMetadata.selfCheckInKiosk,
                'selfcheck-in': convoMetadata.selfCheckInKiosk,
                'checkinkiosk': convoMetadata.selfCheckInKiosk,

                'selfcheckinkiosksettings': convoMetadata.selfCheckInKioskSettings,
                'checkinkiosksettings': convoMetadata.selfCheckInKioskSettings,
                'check-inkiosksettings': convoMetadata.selfCheckInKioskSettings,
                'aveda': convoMetadata.aveda,
                'saloninteractive': convoMetadata.salonInteractive,
                'si': convoMetadata.salonInteractive,
                'emppricing': convoMetadata.employeeServiceTimesPricing,
                'servicepricing': convoMetadata.employeeServiceTimesPricing,
                'emptiming': convoMetadata.employeeServiceTimesPricing,
                'servicetiming': convoMetadata.employeeServiceTimesPricing,
                '5starsettings': convoMetadata.fiveStartRatingSettings,
                '5starratingssettings': convoMetadata.fiveStartRatingSettings,
                'fivestarsettings': convoMetadata.fiveStartRatingSettings,
                'fivestarratingssettings': convoMetadata.fiveStartRatingSettings,

                'servicecharges': convoMetadata.serviceCharges,
                'servicescharges': convoMetadata.serviceCharges,
                'servicecharge': convoMetadata.serviceCharges,
                'servicescharge': convoMetadata.serviceCharges,
                'charges': convoMetadata.serviceCharges,
                'servicefee': convoMetadata.serviceCharges,
                'servicefees': convoMetadata.serviceCharges,
                'housefee': convoMetadata.serviceCharges,
                'housefees': convoMetadata.serviceCharges,
                'housecharge': convoMetadata.serviceCharges,
                'housecharges': convoMetadata.serviceCharges,
                'housetip': convoMetadata.serviceCharges,
                'housetips': convoMetadata.serviceCharges,
                'employeefee': convoMetadata.serviceCharges,
                'employeefees': convoMetadata.serviceCharges,
                'employeecharge': convoMetadata.serviceCharges,
                'employeecharges': convoMetadata.serviceCharges,
                'employeetip': convoMetadata.serviceCharges,
                'employeetips': convoMetadata.serviceCharges,

                //#region Fame Advantage
                'advantage': convoMetadata.fameAdvantage,
                'fameintegration': convoMetadata.fameAdvantage,
                'fameint': convoMetadata.fameAdvantage,
                'fameadvantage': convoMetadata.fameAdvantage,
                'famead': convoMetadata.fameAdvantage,
                'fame': convoMetadata.fameAdvantage,
                //#endregion Fame Advantage
                //#region Product Modal Info
                'bc#': convoMetadata.productInfo,
                'bc=': convoMetadata.productInfo,
                'b#': convoMetadata.productInfo,
                'b=': convoMetadata.productInfo,
                'barcode=': convoMetadata.productInfo,
                'prodlookup': convoMetadata.productInfo,
                'productlookup': convoMetadata.productInfo,
                'prodprice': convoMetadata.productInfo,
                'productprice': convoMetadata.productInfo,
                'prodpricelookup': convoMetadata.productInfo,
                'productpricelookup': convoMetadata.productInfo,
                //#endregion Product Modal Info
                'adppayroll': convoMetadata.adpRunPayroll,
                'adp': convoMetadata.adpRunPayroll,
                'adpintegration': convoMetadata.adpRunPayroll,
                'adppayrollsetting': convoMetadata.adpRunPayroll,
                'adpsettings': convoMetadata.adpRunPayroll,

                'wfn': convoMetadata.adpWfnPayroll,
                'wfnsettings': convoMetadata.adpWfnPayroll,
                'wfnintegration': convoMetadata.adpWfnPayroll,
                'workforce': convoMetadata.adpWfnPayroll,
                'workforcesettings': convoMetadata.adpWfnPayroll,
                'workforcenow': convoMetadata.adpWfnPayroll,
                'workforcenowsettings': convoMetadata.adpWfnPayroll,

                'wisely': convoMetadata.adpWisely,
                'wiselyintegration': convoMetadata.adpWisely,

                'royaltyexport': convoMetadata.royaltyExport,
                'emailmktg': convoMetadata.emma,
                'emma': convoMetadata.emma,
                'emailmarketing': convoMetadata.emma,


                'onlinepresencemgmt': convoMetadata.onlinePresenceManagement,
                'onlinepresence': convoMetadata.onlinePresenceManagement,
                'onlinepresencemanagement': convoMetadata.onlinePresenceManagement,


                'onlinepresencesettings': convoMetadata.onlinePresenceSettings,
                'opsettings': convoMetadata.onlinePresenceSettings,

                'clientutilities': convoMetadata.systemToolbox,
                'utilities': convoMetadata.systemToolbox,
                'clientutility': convoMetadata.systemToolbox,
                'toolbox': convoMetadata.systemToolbox,
                'tool box': convoMetadata.systemToolbox,
                'tools': convoMetadata.systemToolbox,
                'meevosystemtoolbox': convoMetadata.systemToolbox,
                'meevosystemtools': convoMetadata.systemToolbox,
                'meevotoolbox': convoMetadata.systemToolbox,
                'meevotools': convoMetadata.systemToolbox,
                'systemtools': convoMetadata.systemToolbox,
                'systemtoolbox': convoMetadata.systemToolbox,

                'meevocolortheme': convoMetadata.meevoTheming,
                'meevocolorthemes': convoMetadata.meevoTheming,
                'colortheme': convoMetadata.meevoTheming,
                'colorthemes': convoMetadata.meevoTheming,
                'themes': convoMetadata.meevoTheming,
                'meevotheming': convoMetadata.meevoTheming,

                'ymstrategies': convoMetadata.yieldManagementStrategy,
                'ymstrategy': convoMetadata.yieldManagementStrategy,
                'ymstrat': convoMetadata.yieldManagementStrategy,

                'ym': convoMetadata.yieldManagementProgram,
                'yield': convoMetadata.yieldManagementProgram,
                'yieldman': convoMetadata.yieldManagementProgram,
                'yieldmanagement': convoMetadata.yieldManagementProgram,
                'yieldmanprogram': convoMetadata.yieldManagementProgram,
                'yieldmanprograms': convoMetadata.yieldManagementProgram,
                'yieldmanagementprogram': convoMetadata.yieldManagementProgram,
                'yieldmanagementprograms': convoMetadata.yieldManagementProgram,
                'ymprogram': convoMetadata.yieldManagementProgram,
                'ymprograms': convoMetadata.yieldManagementProgram,
                'inventorytransfers': convoMetadata.inventoryTransfer,
                'inventorytransfer': convoMetadata.inventoryTransfer,
                'invxfers': convoMetadata.inventoryTransfer,
                'invxfer': convoMetadata.inventoryTransfer,
                'inventoryxfer': convoMetadata.inventoryTransfer,
                'inventoryxfers': convoMetadata.inventoryTransfer,
                'dataexport': convoMetadata.csvExport,
                'csvexport': convoMetadata.csvExport,
                'data': convoMetadata.csvExport,
                'csv': convoMetadata.csvExport,

                'clientapp': convoMetadata.clientApp,
                'customclientapp': convoMetadata.clientApp,
                'brandedclientapp': convoMetadata.clientApp,

                'businesspreferences': convoMetadata.businessPreferences,
                'busprefs': convoMetadata.businessPreferences,
                'businfopreferences': convoMetadata.businessPreferences,
                'businfoprefs': convoMetadata.businessPreferences,
                'preferences': convoMetadata.businessPreferences,
                'bip': convoMetadata.businessPreferences,
                'MeGo': convoMetadata.clientApp,
                'mego': convoMetadata.clientApp,
                'supplyusagereasons': convoMetadata.usageReasons,
                'supplyusagereason': convoMetadata.usageReasons,
                'usagereason': convoMetadata.usageReasons,
                'usagereasons': convoMetadata.usageReasons,
                'payplanmanager': convoMetadata.paymentPlans,
                'paymentplans': convoMetadata.paymentPlans,
                'paymentplan': convoMetadata.paymentPlans,
                'payplan': convoMetadata.paymentPlans,
                'payplans': convoMetadata.paymentPlans,
                'ppman': convoMetadata.paymentPlans,
                'paymentplanmanager': convoMetadata.paymentPlans,
                'paymentplansmanager': convoMetadata.paymentPlans,
                'payplansmanager': convoMetadata.paymentPlans,
                'dash': convoMetadata.pbiDashboards,
                'dashboard': convoMetadata.pbiDashboards,
                'dashboards': convoMetadata.pbiDashboards,
                'payments': convoMetadata.paymentRequests,
                'tippy': convoMetadata.tippy,
                'tipp': convoMetadata.tippy,
                'tipy': convoMetadata.tippy,
                'tipsy': convoMetadata.tippy,
                'tip': convoMetadata.tippy,
                'tips': convoMetadata.tippy, 
                'meevopay': convoMetadata.meevoPay,
                'pbidashboards': convoMetadata.pbiDashboards,
                'pbi': convoMetadata.pbiDashboards,
                'dwh': convoMetadata.pbiDashboards,
                'dsh': convoMetadata.pbiDashboards,
                'advanceddashboards': convoMetadata.pbiDashboards,
                'powerbi': convoMetadata.pbiDashboards,
                'userdefinedfields': convoMetadata.userDefinedControls,
                'userdefinedfield': convoMetadata.userDefinedControls,
                'udf': convoMetadata.userDefinedControls,
                'udfs': convoMetadata.userDefinedControls,
                'customfields': convoMetadata.userDefinedControls,

                'onlinemembershipsettings': convoMetadata.onlineMembershipSettings,
                'onlinemembership': convoMetadata.onlineMembershipSettings,
                'onlinememberships': convoMetadata.onlineMembershipSettings,
                'onlinemembershipsales': convoMetadata.onlineMembershipSettings,
                'onlinemembershipssales': convoMetadata.onlineMembershipSettings,
                'onlinemembershipsale': convoMetadata.onlineMembershipSettings,
                'onlinemembershipsetting': convoMetadata.onlineMembershipSettings,
                'onlinemembershipsalessetting': convoMetadata.onlineMembershipSettings,
                'onlinemembershipsalessettings': convoMetadata.onlineMembershipSettings,
                'oms': convoMetadata.onlineMembershipSettings,

                'mymeevoapp': convoMetadata.myMeevoApp,
                'mymeevo': convoMetadata.myMeevoApp,

                'pto': convoMetadata.timeOffRequests,
                'paidtimeoff': convoMetadata.timeOffRequests,
                'timeoff': convoMetadata.timeOffRequests,
                'timeoffrequest': convoMetadata.timeOffRequests,
                'timeoffrequests': convoMetadata.timeOffRequests,

                'zapier': convoMetadata.zapier,

                'merchantonboardingtesting': convoMetadata.merchantOnboardingTesting,

                'bulkliabilityupdate': convoMetadata.bulkLiabilityUpdate,
                'bulkliability': convoMetadata.bulkLiabilityUpdate,
                'bulkupdate': convoMetadata.bulkLiabilityUpdate,
                'bulkcancel': convoMetadata.bulkLiabilityUpdate,
                'bulkexpire': convoMetadata.bulkLiabilityUpdate,

                'chartphrases': convoMetadata.chartPhrases,
                'chartphrase': convoMetadata.chartPhrases,
                'chartphr': convoMetadata.chartPhrases,

                'bulkliabilitytransfer': convoMetadata.bulkLiabilityTransfer,
                'bulkliabilitytransfers': convoMetadata.bulkLiabilityTransfer,
                'bulktransfer': convoMetadata.bulkLiabilityTransfer,
                'bulktransfers': convoMetadata.bulkLiabilityTransfer,
                'transfer': convoMetadata.bulkLiabilityTransfer,
                'transfers': convoMetadata.bulkLiabilityTransfer,
                'liabilitytransfer': convoMetadata.bulkLiabilityTransfer,
                'liabilitytransfers': convoMetadata.bulkLiabilityTransfer,

                'upsellopportunities': convoMetadata.upsellOpportunities,
                'upsell': convoMetadata.upsellOpportunities,
                'opportunities': convoMetadata.upsellOpportunities,
                'offer': convoMetadata.upsellOpportunities,
                'offers': convoMetadata.upsellOpportunities,
                'upopp': convoMetadata.upsellOpportunities,

                'aireceptionist': convoMetadata.aiReceptionist,
                'aivoice': convoMetadata.aiReceptionist,
                'receptionist': convoMetadata.aiReceptionist,
                'air': convoMetadata.aiReceptionist,
            };

            if (typeof this.appSettings.APP_FIELDLABELS.then === 'function') {
                this.appSettings.APP_FIELDLABELS.then((data) => {
                    var test = data;
                    _.keys(this.appSettings.APP_FIELDLABELS).forEach((label) => {
                        let key = label.replace(/\s/g, '').toLowerCase();
                        if (_.has(this.convoMap, key)) {
                            this.convoMap[this.appSettings.APP_FIELDLABELS[key].replace(/\s/g, '').toLowerCase()] =
                                this.convoMap[key];
                        }
                    });
                });
            } else {
                _.keys(this.appSettings.APP_FIELDLABELS).forEach((label) => {
                    let key = label.replace(/\s/g, '').toLowerCase();
                    if (_.has(this.convoMap, key)) {
                        this.convoMap[this.appSettings.APP_FIELDLABELS[key].replace(/\s/g, '').toLowerCase()] =
                            this.convoMap[key];
                    }
                });
            }
            // Remove items not supported by CO
            if (this.identityService.inCentralOfficeMode()) {
                // List items not supported in CO
                this.convoMap['clientpointpromo'] = null;
                this.convoMap['clientpointpromos'] = null;
                this.convoMap['clientpointpromotion'] = null;
                this.convoMap['clientpointpromotions'] = null;
                this.convoMap['pricemanagement'] = null;        // Same as marketpricing. User Story 45366 implementation will not work

            } else {
                // List items not supported in non-CO locations
                this.convoMap['marketpricing'] = null;          // Same as pricemanagement. User Story 45366 implementation will not work
                this.convoMap['pricemanagement'].securityKey = this.securityKeys.MANAGEMENT_PRICEMANAGEMENT;

                this.convoMap['multilocationpayroll'] = null;
                this.convoMap['multilocationpayrollpetting'] = null;
                this.convoMap['multilocationpayrollsettings'] = null;
                this.convoMap['multiLocpayroll'] = null;
                this.convoMap['multiLocpayrollsetting'] = null;
                this.convoMap['multilocpayrollsettings'] = null;
                this.convoMap['mlpayroll'] = null;
                this.convoMap['mlpayrollsetting'] = null;
                this.convoMap['mlpayrollsettings'] = null;
            }
           
            // Remove EFTControlPanel for UK
            if (this.appSettings.APP_ISOCOUNTRYCODE === 'GB') {
                this.convoMap['eftcontrolpanel'] = null;
            }

            if (!this.identityService.current().systemSettings.isTestingEnvironment) {
                this.convoMap['merchantonboardingtesting'] = null;
            }

            /*
            * Check for Analytical Report Module
            */
            this.securityService.checkModuleAccess(this.securityKeys.REPORTS_ANALYTICAL + this.securityParts.KEY_PART_READ)
                .then(access => {
                    if (access != Model.SecurityAccessEnum.Grant) {
                        this.convoMap['analyticalreports'] = null;
                        this.convoMap['analyticalrpts'] = null;
                        this.convoMap['analyticalreport'] = null;
                        convoMetadata['reportsAnalytical'] = null;
                    }
                });

            /*
            * Check for Upsell Opportunities Module
            */
            this.securityService.checkModuleAccess(this.securityKeys.UPSELLOPPORTUNITIES)
                .then(access => {
                    if (access != Model.SecurityAccessEnum.Grant) {
                        this.convoMap['upsellopportunities'] = null;
                        this.convoMap['upsell'] = null;
                        this.convoMap['opportunities'] = null;
                        this.convoMap['offer'] = null;
                        this.convoMap['offers'] = null;
                        this.convoMap['upopp'] = null;
                        convoMetadata['upsellOpportunities'] = null;
                    }
                });

            this.dataService.customMethodData(`api/egift/settings`, 'GET', null).then(res => {
                if (res && res.data && (res.data.settings as Model.EGiftsSettings).enableNewEgiftExperience) {
                    this.convoMap['brand'] = this.convoMap['branding'] = this.convoMap['custombranding'] = convoMetadata.advancedCustomBranding;
                }
            });
        }

        public resolveConvoInput(convoInput: string): ng.IPromise<any> {
            var deferred = this.$q.defer();
            var convoResult = new ConvoResult();
            this.giftCardNumber = null;
            convoInput = convoInput.toLowerCase();

            // Handle custom Product Barcode Modal Lookups
            if (convoInput && convoInput.length >= 3 && (convoInput.substring(0, 3) == "bc=" || convoInput.substring(0, 3) == "bc#")) {
                var barcode = convoInput.substring(3);
                this.getProductByBarcodeAndShowProductModal(barcode);
                deferred.resolve(convoResult);
                return deferred.promise;
            }
            else if (convoInput && convoInput.length >= 2 && (convoInput.substring(0, 2) == "b=" || convoInput.substring(0, 2) == "b#")) {
                var barcode = convoInput.substring(2);
                this.getProductByBarcodeAndShowProductModal(barcode);
                deferred.resolve(convoResult);
                return deferred.promise;
            }
            else if (convoInput && convoInput.length >= 8 && convoInput.substring(0, 8) == "barcode=") {
                var barcode = convoInput.substring(8);
                this.getProductByBarcodeAndShowProductModal(barcode);
                deferred.resolve(convoResult);
                return deferred.promise;
            }


            // Custom convos for Employee's default appointment book view.
            var dateAction = null;
            // ADO #128771: tracks whether the convo input was rewritten because
            // the logged-in user's `employeeAppointmentBookViewPreference` is
            // MyDay or MyWeek (the rewrites two branches down). When true, the
            // resulting employee scope is an implicit default-view scope, NOT
            // a user-applied filter — the AB web component reads this flag and
            // routes the employees into a non-filter signal so the filter chip
            // count does not include this scope. Stays false for the explicit
            // "my appointments" rewrite a branch above (that is a user-typed
            // action, so the chip should show).
            var isDefaultEmployeeAppointmentBookView = false;

            if (convoInput == "my appointments") {
                convoInput = `with ${this.LOGGED_IN_EMPLOYEE_TOKEN}`;
            } else if (this.isConvoGeneric(convoInput) && this.identityService.current().employeeAppointmentBookViewPreference == EmployeeAppointmentBookViewEnum.MyDay) {
                convoInput = `today with ${this.LOGGED_IN_EMPLOYEE_TOKEN}`;
                isDefaultEmployeeAppointmentBookView = true;
            } else if (this.isConvoGeneric(convoInput) && this.identityService.current().employeeAppointmentBookViewPreference == EmployeeAppointmentBookViewEnum.MyWeek) {
                dateAction = "week";
                convoInput = `this week with ${this.LOGGED_IN_EMPLOYEE_TOKEN}`;
                isDefaultEmployeeAppointmentBookView = true;
            } else if (convoInput.indexOf("g#") >= 0 || convoInput.indexOf("gc#") >= 0) {
                this.giftCardNumber = convoInput.substring(convoInput.indexOf("#") + 1);
                convoInput = "gcbal";
            } else if (convoInput.indexOf("gc=") >= 0) {
                this.giftCardNumber = convoInput.substring(convoInput.indexOf("=") + 1);
                convoInput = "gcbal";
            } else if (convoInput.indexOf("p#") >= 0) {
                this.packageNumber = convoInput.substring(convoInput.indexOf("#") + 1);
                convoInput = "pkglookup";
            } else if (convoInput.indexOf("p=") >= 0) {
                this.packageNumber = convoInput.substring(convoInput.indexOf("=") + 1);
                convoInput = "pkglookup";
            } else if (convoInput.indexOf("m#") >= 0) {
                this.membershipNumber = convoInput.substring(convoInput.indexOf("#") + 1);
                convoInput = "membershipmanager";
            } else if (convoInput.indexOf("m=") >= 0) {
                this.membershipNumber = convoInput.substring(convoInput.indexOf("=") + 1);
                convoInput = "membershipmanager";
            } else if (convoInput.indexOf("z#") >= 0) {
                this.membershipNumber = convoInput.substring(convoInput.indexOf("#") + 1);
                convoInput = "membershipmanager";
            } else if (convoInput.indexOf("z=") >= 0) {
                this.membershipNumber = convoInput.substring(convoInput.indexOf("=") + 1);
                convoInput = "membershipmanager";
            } else if (convoInput.indexOf("merchantaccounttesting") == 0) {
                var convoInputSplit = convoInput.split(" ");
                if (convoInputSplit[1] == "on") {
                    document.cookie = "AllowTestMerchantAccount=1234567890ABCDEFGHIJKLMNOPQRSUVWXYZ;";
                }
                else if (convoInputSplit[1] == "off") {
                    document.cookie = "AllowTestMerchantAccount=; expires=Thu, 01 Jan 1970 00:00:00 UTC;"
                }
                convoResult.status = ConvoStatus.ResolvedWithNoAction;
                deferred.resolve(convoResult);
                return deferred.promise;
            } else if (convoInput.indexOf("upselltesting") == 0) {
                if (this.identityService.current().userTypeEnum !== Model.UserTypeEnum.MSIUser) {
                    convoResult.status = ConvoStatus.Unresolved;
                } else {
                    var convoInputSplit = convoInput.split(" ");
                    if (convoInputSplit[1] == "on") {
                        document.cookie = "AllowTestUpsell=1234567890ABCDEFGHIJKLMNOPQRSUVWXYZ;";
                    }
                    else if (convoInputSplit[1] == "off") {
                        document.cookie = "AllowTestUpsell=; expires=Thu, 01 Jan 1970 00:00:00 UTC;"
                    }
                    convoResult.status = ConvoStatus.ResolvedWithNoAction;
                }
                deferred.resolve(convoResult);
                return deferred.promise;
            }            
            // Custom convos for Employee's default appointment book view. End
            var match = this.convoMap[convoInput];
            if (_.isEmpty(convoInput)) {
                convoResult.status = ConvoStatus.Resolved;
                deferred.resolve(convoResult);
            } else if (_.isEmpty(match)) {

                this.callConvoApi(convoInput).then((result: any) => {
                    if (result.requestId === this.activeRequestId) {
                        let match = new ConvoMetadata(result.route, null);
                        convoResult.status = result.status;
                        convoResult.suggestedCommands = result.suggestedCommands;
                        const effectiveRoute = result.route === this.routeNames.reports && result.payload
                            ? result.payload.report.toLowerCase()
                            : result.route;

                        if (result.route && this.isInCallCenterAndRouteBlocked(effectiveRoute)) {
                            convoResult.status = ConvoStatus.NoAccess;
                            convoResult.isInCallCenterAndRouteBlocked = true;
                            deferred.resolve(convoResult);
                        } else if (convoResult.status === ConvoStatus.Resolved) {
                            if (dateAction) {
                                result.payload["dateAction"] = dateAction;
                            }
                            // ADO #128771: see comment near the MyDay/MyWeek
                            // rewrites above. Forward the flag so the AB web
                            // component can distinguish default-view scope
                            // from user-applied filters.
                            if (isDefaultEmployeeAppointmentBookView) {
                                result.payload["isDefaultEmployeeAppointmentBookView"] = true;
                            }
                            this.checkAndBroadcast(match, convoResult, result.payload);
                        }

                    } else {
                        // When no match is detected it could be that the convo input
                        // could not be processed in the current location
                        convoResult.status = ConvoStatus.Unresolved;
                    }

                    // check if an employee does not perform any of the services requested in the convo bar
                    if (result.payload != null && result.payload.EmployeeDoesNotPerformService != null) {
                        var employeeNotPerformingServicesString = "";
                        for (var i = 0; i < result.payload.EmployeeDoesNotPerformService.length; i++) {
                            employeeNotPerformingServicesString += result.payload.EmployeeDoesNotPerformService[i].key + " " + this.$translate.instant("MESSAGE_IS_NOT_CONFIGURED_TO_PERFORM") + " " + result.payload.EmployeeDoesNotPerformService[i].value + ". ";
                        }
                        convoResult.employeeDoNotPerformServicesList = employeeNotPerformingServicesString;
                    }

                    deferred.resolve(convoResult);
                });
            } else {
                var state = _.findWhere(this.states, { name: match.route });
                if (match.route == this.routeNames.productInfoModal) {
                    this.getProductByBarcodeAndShowProductModal(null);
                    deferred.resolve(convoResult);
                    return deferred.promise;
                }
                else if (match.route == this.routeNames.paymentRequests &&
                    this.identityService.current().userTypeEnum !== Model.UserTypeEnum.MSIUser) {
                    convoResult.status = ConvoStatus.Unresolved;
                }
                else if (match.isNewTabPromise) {
                    this.openBrowserTab(match, convoResult).then(newConvoResult => deferred.resolve(newConvoResult));
                    return deferred.promise;
                } else if (_.isEmpty(state)) {
                    convoResult.status = ConvoStatus.Unresolved;
                } else if (this.isInCallCenterAndRouteBlocked(match.route, match.routeParams)) {
                    convoResult.status = ConvoStatus.NoAccess;
                    convoResult.isInCallCenterAndRouteBlocked = true;
                } else if(match.securityKey instanceof Array) {
                    let params = {...match.routeParams, ...this.processKeyword(convoInput)};
                    // ADO #128771: forward the default-view flag on the
                    // cached-convoMap path too (rare for the MyDay/MyWeek
                    // rewrites, which usually hit callConvoApi, but kept
                    // here for parity in case a convoMap entry ever matches).
                    if (isDefaultEmployeeAppointmentBookView) {
                        params["isDefaultEmployeeAppointmentBookView"] = true;
                    }
                    this.checkMultipleKeysAndBroadCast(match, convoResult, params)
                        .then((newConvoResult) => deferred.resolve(newConvoResult));

                    return deferred.promise;
                }
                else {
                    let params = {...match.routeParams, ...this.processKeyword(convoInput)};
                    if (isDefaultEmployeeAppointmentBookView) {
                        params["isDefaultEmployeeAppointmentBookView"] = true;
                    }
                    this.checkAndBroadcast(match, convoResult, params);
                }
                deferred.resolve(convoResult);
            }

            return deferred.promise;
        }

        private openBrowserTab(match: ConvoMetadata, convoResult: ConvoResult) {
            return this.securityService.checkSecurityItem(match.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((result: Model.SecurityItem) => {
                    if (result.securityAccess === SecurityAccessEnum.Deny || result.securityAccess === SecurityAccessEnum.Hide) {
                        convoResult.status = ConvoStatus.NoAccess;
                        convoResult.security = {
                            role: result.roleSecurityAccess,
                            availabilityLevel: result.availabilityLevelSecurityAccess,
                            module: result.moduleSecurityAccess,
                            securityKeyPath: result.securityKeyPath
                        }
                        return convoResult;
                    } else {
                        convoResult.status = ConvoStatus.Resolved;
                        convoResult.stateName = match.route;
                        convoResult.isBrowserTab = true;

                        try {
                           return match.isNewTabPromise()
                                .then(url => {
                                    if (url) {
                                        this.$window.open(url, '_blank');
                                    }
                                    return convoResult;
                                });
                        } catch (e) {
                            return convoResult;
                        }
                    }
                });
        }

        private checkMultipleKeysAndBroadCast(match: ConvoMetadata, convoResult: ConvoResult, params: any): ng.IPromise<ConvoResult> {
            const keys = match.securityKey instanceof Array
                ? match.securityKey.map(key => key + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                : [match.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ];

            return this.securityService.checkMultipleKeys(...keys)
                .then((result: Model.SecurityItem | null) => {
                    if (result && (result.securityAccess === SecurityAccessEnum.Deny || result.securityAccess === SecurityAccessEnum.Hide)) {
                        convoResult.status = ConvoStatus.NoAccess;
                        convoResult.security = {
                            role: result.roleSecurityAccess,
                            availabilityLevel: result.availabilityLevelSecurityAccess,
                            module: result.moduleSecurityAccess,
                            securityKeyPath: result.securityKeyPath
                        }
                    } else {
                        convoResult = this.broadcastAndResolve(convoResult, match, params);
                    }

                    return convoResult;
                });
        }

        private checkAndBroadcast(match: ConvoMetadata, convoResult: ConvoResult, params: any) {
            if ((match.route === 'bookingAgent' || match.route === 'notificationTemplates') && device.mobile()) {
                return this.modalService.alert("LABEL_NOT_AVAILABLE_ON_MOBILE");
            }
            if (_.isEmpty(match.securityKey)) {
                convoResult = this.broadcastAndResolve(convoResult, match, params);
            } else {
                if (match.route === this.routeNames.clientIntake) {
                    this.securityService.checkSecurityItemWithElevation(match.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                        .then(() => {
                            convoResult = this.broadcastAndResolve(convoResult, match, params);
                        });
                } else {
                    this.securityService.checkSecurityItem(match.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                        .then((result: Model.SecurityItem) => {
                            if (result.securityAccess === SecurityAccessEnum.Deny || result.securityAccess === SecurityAccessEnum.Hide) {
                                convoResult.status = ConvoStatus.NoAccess;
                                convoResult.security = {
                                    role: result.roleSecurityAccess,
                                    availabilityLevel: result.availabilityLevelSecurityAccess,
                                    module: result.moduleSecurityAccess,
                                    securityKeyPath: result.securityKeyPath
                                }
                            } else {
                                convoResult = this.broadcastAndResolve(convoResult, match, params);
                            }
                        });
                }

            }
        }

        private broadcastAndResolve(convoResult, match, params) {
            let result = convoResult;
            result.status = ConvoStatus.Resolved;
            result.stateName = match.route;
            this.$rootScope.$broadcast('menuItemSelectedViaConvo', match.route, params);
            return result;
        }

        // TODO: Review how we want to structure the "processors" that will infer more info beyond just resolving
        // to a canned state. In the meantime, we are going to check some special keywords here to add params.
        // This is super primitive - the real process entry point will be promise-based and have to evaluate the whole
        // stream of incoming word combinations.
        private processKeyword(keyword: string): any {
            let params = {};
            keyword = keyword.toLowerCase();
            if (keyword == 'tomorrow') {
                params = {
                    dateAction: 'tomorrow'
                }
            }
            if (keyword == 'today' || keyword == 'appointment' || keyword == 'appointment book' || keyword == 'appointmentbook' || keyword == 'book') {
                params = {
                    dateAction: 'today'
                }
            }
            if (keyword == 'my appointments') {
                params = {
                    employeeAction: 'self',
                    employee: this.identityService.current().user
                }
            }
            if (keyword == 'gcbal' && this.giftCardNumber) {
                params = {
                    giftCardNumber: this.giftCardNumber
                };
            }

            if (keyword == 'pkglookup' && this.packageNumber) {
                params = {
                    packageNumber: this.packageNumber
                };
            }

            if (keyword == 'membershipmanager' && this.membershipNumber) {
                params = {
                    membershipNumber: this.membershipNumber
                };
            }

            params['convoInput'] = keyword;

            return params;
        }

        /**
         * Gets the default convo string for a given state/route. This is used primarily to sync the convo bar with a route that has been navigated to manually.
         * Currently just looking for the first keyword in the convoMap for the specified state. This will need to be more intelligent once the convo describes more of the overall state of the context.
         */
        getDefaultConvoForState(stateName) {
            var convo = '';
            // TODO: Something more efficient so we don't have to iterate through the entire convo map
            _.each(this.convoMap, (val, key) => {
                if (val && val.route.toLowerCase() == stateName.toLowerCase() && _.isEmpty(convo)) {
                    convo = key;
                }
            });

            return convo;
        }

        private callConvoApi(input: string) {
            let deferred = this.$q.defer();
            let url = '/api/Convo/Process';
            let requestId = NewGuid();
            this.activeRequestId = requestId;
            let params = {
                input: input,
                requestId: requestId
            };
            this.$http.get(url, { params: params }).then((response) => {
                let r = response;
                deferred.resolve(r.data);
            }).catch(() => {
            });
            return deferred.promise;
        }

        private isConvoGeneric(convoInput: string) {
            return (convoInput == "appointment" || convoInput == "appointment book" || convoInput == "appointmentbook" || convoInput == "book");
        }

        private getProductByBarcodeAndShowProductModal(barcode: string) {

            return this.securityService.checkSecurityItem(Meevo.Components.Common.SecurityKeys.INVENTORY_PRODUCTMODAL + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((result: Model.SecurityItem) => {
                    if (result.securityAccess === SecurityAccessEnum.Grant) {
                        var modalOptions: Meevo.Plugins.Product.ProductInfoModalOptions = {
                            parentType: Meevo.Plugins.Product.ProductInfoModalParent.Convobar
                        }
                        if (barcode && barcode.length >= 1) {
                            var criteria = {
                                "criteria": {
                                    "IncludeNotForSale": true,
                                    "IsProductBundle": false,
                                    "NotForSale": null,
                                    "businessType": null,
                                    "coBusinessTypeId": null,
                                    "coFilterByLocationId": null,
                                    "coSearchResultFilter": 0,
                                    "coSearchType": null,
                                    "filter": barcode,
                                    "floorId": null,
                                    "includeActive": true,
                                    "includeDeleted": false,
                                    "location": null,
                                    "maintenanceMode": true,
                                    "productInventoryType": null,
                                    "variantObjectState": [2026]
                                },
                                "IncludeNotForSale": 1,
                                "itemsPerPage": 1,
                                "pageNumber": 0,
                                "sortBy": null,
                                "sortDirection": 0
                            }
                            this.$http.post('api/Product/List', criteria).then((response) => {
                                if (response.data && response.data["length"] >= 1) {
                                    var item = response.data[0];
                                    modalOptions.productId = item["id"];

                                    let options: Meevo.Components.Modal.IModalOptions = {
                                        templateUrl: "app/plugins/product/modals/productInformation.template.html",
                                        controller: "meevo.plugins.product.ProductInformationController",
                                        controllerAs: "vm",
                                        bindToController: true,
                                        locals: {
                                            options: modalOptions
                                        }
                                    }
                                    this.modalService.showCustom(options);
                                }
                            });
                        }
                        else {
                            let options: Meevo.Components.Modal.IModalOptions = {
                                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                                controller: "meevo.plugins.product.ProductInformationController",
                                controllerAs: "vm",
                                bindToController: true,
                                locals: {
                                    options: modalOptions
                                }
                            }
                            this.modalService.showCustom(options);
                        }
                    }
            });

        }

        private isInCallCenterAndRouteBlocked(route: string, routeParams?: any): boolean {
            let isRouteBlocked = false;
            if (route === this.routeNames.reports && routeParams && routeParams.categoryId) {
                isRouteBlocked = !!_.findWhere(this.reportsCategoriesBlockedAtCallCenter, categoryId => categoryId === routeParams.categoryId);
            } else {
                isRouteBlocked = this.callCenterBlockedRouteNames.indexOf(route) > -1;
            }

            return this.identityService.inCallCenterMode()
                        && !this.identityService.isEmulating
                        && isRouteBlocked;
        }

        productCriteria = {
            coSearchResultFilter: 0
        }

        getProductCriteria() {
            if (this.identityService.isApplicationModeCO) {
                return this.productCriteria;
            }
            return {};
        }

        public closeModal() {
            this.modalService.hide();
        }


        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, $q: ng.IQService, $state: ng.ui.IStateService, $rootScope: ng.IRootScopeService, securityService: Meevo.Components.Common.ISecurityService, $http: ng.IHttpService, identityService: Meevo.Components.Common.IdentityService, modalService: Meevo.Components.Modal.IModalService, $translate: angular.translate.ITranslateService, businessInfoDataService: IBusinessInfoDataService, $window: ng.IWindowService, dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new ConvoService(appSettings, $q, $state, $rootScope, securityService, $http, identityService, modalService, $translate, businessInfoDataService, $window, dataService);
            }

            svc.$inject = ['meevo.AppSettings', '$q', '$state', '$rootScope', 'meevo.components.common.SecurityService', '$http', 'meevo.components.common.IdentityService', "meevo.components.modal.ModalService", '$translate', "meevo.components.common.BusinessInfoDataService", "$window", "meevo.components.common.DataService"];
            return svc;
        }
    }

    angular.module("meevo")
        .factory("meevo.convo.ConvoService", ConvoService.factory());
}
